export const lastParticipantNameFormatter = (full_name: string, maxLength: number = 30) => {
  var formatted_name = full_name.trim();
  try {
    // Apply capitalization
    formatted_name = formatted_name
      .toLowerCase()
      .split(" ")
      .map(function (name_part) {
        return name_part.replace(name_part[0], name_part[0].toUpperCase());
      })
      .join(" "); 
    
    // Truncate aith ellipsis if longer than maxLength
    if (formatted_name.length > maxLength) {
      return formatted_name.substring(0, maxLength) + "...";
    }
    
    return formatted_name;
  } catch (error) {
    // Log error in TrackJS
    (window as any)['TrackJS'].track(error);
    // Give up and move on if we can't properly format
    return full_name;
  }
};
